import spacings from 'shared-tokens/utils/tokens/spacings';

export const mainCls = 'list-chk-item';
export const gridLabelCls = `${mainCls}__grid-label`;
export const gridForDescCls = `${mainCls}__grid-forDesc`;
export const gridWithDescCls = `${mainCls}__grid-withDesc`;
export const gridIconCls = `${mainCls}__grid-icon`;
export const labelAccordCls = `${gridLabelCls}--has-acc`;
export const labelNoAccordCls = `${gridLabelCls}--no-acc`;

export default {
  [gridLabelCls]: {
    padding: spacings.m,
  },
  [gridForDescCls]: {
    paddingTop: 19,
    paddingBottom: 19,
  },
  [gridWithDescCls]: {
    paddingTop: 11,
    paddingBottom: 11,
  },
  [gridIconCls]: {
    padding: spacings.m,
  },
  [labelAccordCls]: {
    paddingRight: 0,
  },
};
